import type { LC, LiveElement, PropsWithChildren } from '@use-gpu/live';

import { use, deprecated, memo } from '@use-gpu/live';

import { Compute } from './compute';
import { DispatchLoop } from '../queue/dispatch-loop';

/** @hidden */
export type ComputeLoopProps = PropsWithChildren<{
  /** Always run initial iteration immediately */
  initial?: boolean,
  /** Loop is running */
  live?: boolean,
  /** Continue iteration count even if program changes */
  continued?: boolean,
  /** Batch # of dispatches together */
  batch?: number,
  /** Limit # of dispatches */
  limit?: number,

  then?: (count: number) => LiveElement,
}>;

/** @hidden */
const ComputeLoopDeprecated: LC<ComputeLoopProps> = memo((props: ComputeLoopProps) => {
  const {children, ...rest} = props;
  return use(DispatchLoop, {...rest, children: use(Compute, {children})});
}, 'ComputeLoop');

/** @hidden */
export const ComputeLoop = deprecated(ComputeLoopDeprecated, 'ComputeLoop', 'DispatchLoop> + <Compute');
